import type { BuilderDaSimulacao, NegociacaoSimulacaoState } from '../../types';
import {
  configuracaoAlteradaDetectada,
  contextoDoAdminAberto,
  contextoDoAdminFechado,
  escritorioDoAdminTrocado,
  modoDoAdminEscolhido,
} from '../eventosDoStore';
import { descartarConversa, reiniciarContexto } from '../transicoesDaSimulacao';
import { buscarConfiguracaoDoAdmin } from './actions';

/**
 * O formulário do admin nasce com o fluxo da URL: o core resolve o principal do agente a partir
 * dele (decisão provisória 2), na configuração e no início.
 */
const contextoNovoDoAdmin = (
  state: NegociacaoSimulacaoState,
  flowId: string,
  escritorioId: string | null,
): NegociacaoSimulacaoState => ({
  ...reiniciarContexto(state, escritorioId),
  superficie: 'ADMIN',
  contextoAdmin: { flowId, escritorioId, modo: null },
  formulario: { flowId, valores: {} },
});

export function registrarSimulacaoDoAdmin(builder: BuilderDaSimulacao): void {
  builder
    .addCase(contextoDoAdminAberto, (state, action) =>
      contextoNovoDoAdmin(state, action.payload.flowId, action.payload.escritorioId),
    )
    // O modo também volta ao início: a atual do outro escritório traz o dela (CA-2).
    .addCase(escritorioDoAdminTrocado, (state, action) => {
      if (!state.contextoAdmin) return;
      return contextoNovoDoAdmin(state, state.contextoAdmin.flowId, action.payload);
    })
    .addCase(contextoDoAdminFechado, (state) => {
      if (state.superficie !== 'ADMIN') return;
      return reiniciarContexto(state, null);
    })
    .addCase(modoDoAdminEscolhido, (state, action) => {
      if (!state.contextoAdmin) return;
      state.contextoAdmin.modo = action.payload;
      state.formulario = { flowId: state.contextoAdmin.flowId, valores: {} };
      state.versaoDoFormulario += 1;
      state.ultimaAlteracaoDoFormulario = 'DADOS_ALTERADOS';
      state.erroDoInicio = null;
      descartarConversa(state);
    })
    .addCase(configuracaoAlteradaDetectada, (state, action) => {
      if (state.simulacao?.id === action.payload) state.configuracaoAlteradaEm = action.payload;
    })
    .addCase(buscarConfiguracaoDoAdmin.pending, (state, action) => {
      state.configuracaoAdmin.carregando = true;
      state.configuracaoAdmin.erro = null;
      state.configuracaoAdmin.requisicaoVigente = action.meta.requestId;
    })
    .addCase(buscarConfiguracaoDoAdmin.fulfilled, (state, action) => {
      if (state.configuracaoAdmin.requisicaoVigente !== action.meta.requestId) return;
      state.configuracaoAdmin.carregando = false;
      state.configuracaoAdmin.requisicaoVigente = null;
      if (state.contextoAdmin?.escritorioId !== action.meta.arg.escritorioId) return;
      state.configuracaoAdmin.dados = action.payload;
    })
    .addCase(buscarConfiguracaoDoAdmin.rejected, (state, action) => {
      if (state.configuracaoAdmin.requisicaoVigente !== action.meta.requestId) return;
      state.configuracaoAdmin.carregando = false;
      state.configuracaoAdmin.requisicaoVigente = null;
      state.configuracaoAdmin.erro = action.payload ?? null;
    });
}
